/**
 * @desc 查看参数详情
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** code */
  code: string;
  /** equipmentCode */
  equipmentCode?: string;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<defs.ParamDetailResponse>> {
  return defHttp.get({
    url: '/wap/ParamManage/getParamDetailByCode',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<defs.ParamDetailResponse>> {
  return defHttp.get({
    url: '/mock/wap/ParamManage/getParamDetailByCode',

    params,
  });
}
